
export function useDescription() {
  const description = [
    'Showing long-term correlation between Crude Oil and Crop Price Index',
    'Corn, Wheat and Soybean are considered in the calculation of Crop Price Index',
    'Source: USDA Prices, EIA Crude Oil Prices',
  ];
  return description;
}